import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { EMPTY_DASH } from '@/helpers/constants';
import { prettyFloatMoney } from '@/helpers/utils';
import s from './index.module.scss';

export const LoanTermStatus = ({ status, className }) => {
  const { t } = useTranslation();

  if (!status) return null;

  return (
    <div className={classnames(s.wrapper, className)}>
      <h3 className={classnames(s.title, 'f-article-accent')}>
        {t('fundraising:loan_term_status.loan_terms')}
      </h3>
      <div className={s.statistics}>
        <div className={classnames(s.row, 'f-body')}>
          <div className="f-small-accent">{t('fundraising:loan_term_status.plan')}</div>
          <div className="f-small-regular">
            {status.tariff_plan ? (
              <span>
                <span style={{ textTransform: 'capitalize' }}>
                  {status.tariff_plan.title?.toLocaleLowerCase()}
                </span>{' '}
                {status.tariff_plan.fee}% {t('fundraising:loan_term_status.flat_fee')}
              </span>
            ) : (
              EMPTY_DASH
            )}
          </div>
        </div>
        <div className={classnames(s.row, 'f-body')}>
          <div className="f-small-accent">{t('fundraising:loan_term_status.fpg_option')}</div>
          <div className="f-small-regular">
            {status.fpg_option ? status.fpg_option.title : EMPTY_DASH}
          </div>
        </div>
        {status?.fpg_assets_status && (
          <div className={classnames(s.row, 'f-body')}>
            <div className="f-small-accent">{t('fundraising:loan_term_status.status')}</div>
            <div className="f-small-regular">
              <span className={classnames(s.fpg_asset_badge, status.fpg_assets_status)}>
                {t(`dynamic:fpg_assets_status.${status.fpg_assets_status}`)}
              </span>
            </div>
          </div>
        )}
        {status?.flexibility_option && (
          <div className={classnames(s.row, 'f-body')}>
            <div className="f-small-accent">{t('fundraising:loan_term_status.payment_flexibility')}</div>
            <div className="f-small-regular">
              {status.flexibility_option?.fee_amount
                ? t('fundraising:loan_term_status.fee_amount', {
                    amount: prettyFloatMoney(status.flexibility_option.fee_amount),
                  })
                : t('fundraising:loan_term_status.not_enabled')}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
